import { createAsyncThunk } from "@reduxjs/toolkit";
import { checkStatus, AuthError, composeAuth } from "../../helpers/utils";
import { logoutUser } from "../actions/account";

export const getBulkEditJobById = createAsyncThunk(
    "job/getBulkEditJobById",
    async (payload, thunkApi) => {
        try {
            const url =
                process.env.REACT_APP_SERVER + `/api/goals/goalbulkjob/ininstitution/${payload?.institutionId}/bulk/${payload?.bulkId}/goalbulkjob`;
            const Authorization = composeAuth(payload?.jwt);
            const res = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                    Authorization,
                },
            });

            const response = await res.json();

            const validateData = checkStatus(response);
            return validateData?.data;
        } catch (err) {
            if (err instanceof AuthError) {
                thunkApi.dispatch(logoutUser());
            }
            return thunkApi.rejectWithValue(err);
        }
    }
);

export const getBulkEditJobByTagId = createAsyncThunk(
    "job/getBulkEditJobByTagId",
    async (payload, thunkApi) => {
        try {
            const Authorization = composeAuth(payload?.jwt);
            const url = process.env.REACT_APP_SERVER + `/api/goals/goalbulkjob/ininstitution/${payload?.institutionId}/tag/${payload?.tagId}/goalbulkjobTag`;
            const res = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                    Authorization,
                },
                body: JSON.stringify(payload?.body),
            });

            const response = await res.json();
            const validateData = checkStatus(response);
            return validateData?.data;
        } catch (err) {
            if (err instanceof AuthError) {
                thunkApi.dispatch(logoutUser());
            }
            return thunkApi.rejectWithValue(err);
        }
    }
);

export const getActiveLogBulkEditJobsByTag = createAsyncThunk(
    "job/getActiveLogBulkEditJobsByTag",
    async (payload, thunkApi) => {
        try {
            const Authorization = composeAuth(payload?.jwt);
            const url =
                process.env.REACT_APP_SERVER +
                `/api/goals/institution/${payload?.institutionId}/tag/${payload?.tagId}/bulk-jobs/active`;
            const res = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                    Authorization,
                },
            });

            const response = await res.json();
            const validateData = checkStatus(response);

            return {
                tagId: String(payload?.tagId || ""),
                jobs: Array.isArray(validateData?.data) ? validateData.data : [],
            };
        } catch (err) {
            if (err instanceof AuthError) {
                thunkApi.dispatch(logoutUser());
            }
            return thunkApi.rejectWithValue(err);
        }
    }
);

export const getBulkEditJobByModule = createAsyncThunk(
    "job/getBulkEditJobByModule",
    async (payload, thunkApi) => {
        try {
            const Authorization = composeAuth(payload?.jwt);
            const url = process.env.REACT_APP_SERVER + `/api/goals/goalbulkjob/ininstitution/${payload?.institutionId}/module/${payload?.moduleName}/goalbulkjobTag`;
            const res = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                    Authorization,
                },
                body: JSON.stringify(payload?.body),
            });

            const response = await res.json();
            const validateData = checkStatus(response);
            return validateData?.data;
        } catch (err) {
            if (err instanceof AuthError) {
                thunkApi.dispatch(logoutUser());
            }
            return thunkApi.rejectWithValue(err);
        }
    }
);
